var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{ref:"pageChild",on:{"rollInit":_vm.rollInitEvent,"rollEnd":_vm.rollEndEvent,"rollTop":_vm.rollTopEvent,"rollPage":_vm.rollPageEvent},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }